import { supabase } from '@/lib/supabase';

interface DefaultBranchRecord {
  id: string;
}

export async function resolveDefaultBranchId(
  explicitBranchId?: string | null,
  cachedBranchId?: string | null
): Promise<string | null> {
  if (explicitBranchId) {
    return explicitBranchId;
  }

  if (cachedBranchId) {
    return cachedBranchId;
  }

  if (!supabase) {
    return null;
  }

  const { data, error } = (await supabase
    .from('branches')
    .select('id')
    .eq('is_main', true)
    .single()) as { data: DefaultBranchRecord | null; error: unknown };

  if (error || !data?.id) {
    return null;
  }

  return data.id;
}
